import React, {Component} from 'react';
import IFrameContainer from "../../utils/IFrameContainer";
import ModuleNav from "../../mainFrame/ModuleNav";
import StaticVideoFunctions from "../../utils/StaticVideoFunctions";
import Job from "../../utils/Job";
import PropTypes from "prop-types";
import SoftwareVideoSmall from "./SoftwareVideoSmall";
import SoftwareVideoMedium from "./SoftwareVideoMedium";
import SoftwareVideoTable from "./SoftwareVideoTable";

class SoftwareVideoListContainer extends Component {

    static propTypes = {
        videoSource: PropTypes.string.isRequired,
        activeVideoCategory: PropTypes.string.isRequired,
        videoList: PropTypes.object.isRequired,
        handleStateChange: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: 'smallView',
            videoList: [],
        };

        this.translate = this.props.baseData.translate;

        this.handleViewChange = this.handleViewChange.bind(this);
        this.setModalContent = this.setModalContent.bind(this);

    }

    componentWillMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};

        //  View aus den userprops laden
        const activeView = (settings.viewVideos) ? settings.viewVideos : 'smallView';

        if (activeView) state.activeView = activeView;

        this.setState(state);

    }

    componentWillUnmount() {

        this.props.handleStateChange();

    }

    handleViewChange(view) {

        this.props.baseData.saveSettings('viewVideos', view);

        this.setState({activeView: view});

    }

    navigate(event) {

        if (this.props.onClick) {
            event.preventDefault();

            this.props.onClick();
        }

        return null;

    }

    getVideoList() {

        if (this.props.activeVideoCategory && this.props.videoList) {
            const activeCategory = this.props.activeVideoCategory;
            const videos = this.props.videoList;

            if (typeof videos !== 'undefined') {
                if (typeof videos['video-' + activeCategory] !== 'undefined') {
                    if (videos['video-' + activeCategory].length > 0) {
                        return videos['video-' + activeCategory];
                    }
                }
            }
        }

        return [];

    }

    getVideoById(videoId) {

        const videoList = this.getVideoList();

        let videoData = null;

        if (videoList.length > 0) {
            videoList.map((item) => {
                if (videoId === item.video_id) {
                    videoData = item;
                }
            });
        }

        return videoData;

    }

    setModalContent(v) {

        if (!v) return null;

        const videoData = this.getVideoById(v);
        const videoUrl = StaticVideoFunctions.getVideoUrl(videoData.video_id, this.props.videoSource);

        this.props.baseData.modalData({
            content: <IFrameContainer
                height="replaceModalContentHeight"
                width="replaceModalContentWidth"
                src={videoUrl}
            />
        });

    }

    renderVideos() {

        if (this.props.activeVideoCategory && this.props.videoList) {
            const videos = this.getVideoList();
            const activeView = this.state.activeView;

            if (activeView === 'smallView') {
                return <SoftwareVideoSmall
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={this.props.videoSource}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'mediumView') {
                return <SoftwareVideoMedium
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={this.props.videoSource}
                    translate={this.translate}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'tableView') {
                return <SoftwareVideoTable
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={this.props.videoSource}
                    onClick={this.setModalContent}
                />;
            } else {
                return this.translate('noViewFound');
            }
        }

        return this.translate('noVideosFound');

    }

    renderStyles() {

        const videos = this.getVideoList();
        const videoCounter = videos.length;
        const maxTimeForFadeIn = (videoCounter >= 10) ? 2 : 1;
        const secondsPerChild = maxTimeForFadeIn / videoCounter;

        let styles = '';

        for (let i = 1; i <= videoCounter; i++) {
            styles += '.fadeInArea .fadeInItem:nth-child(' + i + ') { animation-delay: ' + i * secondsPerChild + 's; } ';
        }

        return styles;

    }

    render() {

        const archivAreaClasses = ['archivArea', this.state.activeView].join(' ').trim();
        const videos = this.renderVideos();

        if (this.props.videoSource) {
            return (
                <div className="videoListContainer">
                    <nav>
                        <h1>{this.props.activeVideoCategoryName}</h1>

                        <ModuleNav translate={this.translate}
                                   activeView={this.state.activeView}
                                   onClick={this.handleViewChange}
                        />
                    </nav>

                    <div className={archivAreaClasses}>
                        <div className="fadeInArea clearfix">
                            {videos}
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        <a className="prewLink" onClick={(e) => this.navigate(e)}>{this.translate('backToOverview')}</a>
                    </div>
                </div>
            );
        } else {
            return <div>&nbsp;</div>;
        }

    }

}

export default SoftwareVideoListContainer;